var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 51,
    viewBox: "0 0 58 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4526 0L42.8291 2.7228L45.9072 3.1621L43.6799 5.28031L44.2055 8.27277L41.4526 6.85918L38.6997 8.27277L39.2253 5.28031L36.998 3.1621L40.0762 2.7228L41.4526 0Z",
    fill: "#F0BC57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1362 5.09082L51.184 11.1648L57.9998 12.1447L53.068 16.87L54.2319 23.5455L48.1362 20.3921L42.0404 23.5455L43.2043 16.87L38.2725 12.1447L45.0883 11.1648L48.1362 5.09082Z",
    fill: "#F0BC57"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8335 9.54541C25.5841 9.54541 8.37057 9.54541 5.18311 12.0936C2 14.6397 2 18.7403 2 26.9395C2 35.1386 2 37.065 5.18311 39.611C6.56811 40.7199 8.31838 41.3439 10.697 41.6983V48.682C15.4804 45.9381 18.2852 42.1592 23.7425 42.1592C33.992 42.1592 45.4825 42.1592 48.6635 39.611C51.8488 37.065 51.8488 35.1386 51.8488 26.9395",
    stroke: "#0D498A",
    strokeWidth: 3.40228,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.63477,
    y: 18.4551,
    width: 18.4547,
    height: 1.9091,
    rx: 0.954551,
    fill: "#0D498A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.63477,
    y: 31.8188,
    width: 18.4547,
    height: 1.9091,
    rx: 0.954551,
    fill: "#0D498A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.63477,
    y: 22.9097,
    width: 21.6365,
    height: 1.9091,
    rx: 0.954551,
    fill: "#0D498A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9.63477,
    y: 27.3633,
    width: 24.8183,
    height: 1.9091,
    rx: 0.954551,
    fill: "#0D498A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalLogo);
export default __webpack_public_path__ + "static/media/modal-logo.f96775834efd1aee6daa45b575bc8d4d.svg";
export { ForwardRef as ReactComponent };